module.exports = __webpack_public_path__ + "img/github.c1356d39.svg";